const isDev = false;
const LOCAL_IP = "localhost";
const isLocalFrontend = ["localhost", "127.0.0.1"].includes(
  window.location.hostname
);

const config = {
  API_BASE_URL: isLocalFrontend
    ? "/admin/api/v1"
    : isDev
      ? `http://${LOCAL_IP}:5001/admin/api/v1`
      : "https://api.topsekk.com/admin/api/v1",
  WS_URL: isDev ? `ws://${LOCAL_IP}:7400/ws` : "wss://socket.topsekk.com/ws",
  CDN_URL: "https://cdn.topsekk.com",
  environment: isDev ? "development" : "production",
  isDevelopment: isDev,
  isProduction: !isDev,
};

const envConfig = {
  config,
  isDevelopment: config.isDevelopment,
  isProduction: config.isProduction,
  getApiUrl: () => config.API_BASE_URL,
  getWebSocketUrl: () => config.WS_URL,
  getCdnUrl: () => config.CDN_URL,
};

export default envConfig;
